<!-- <div class="mermaid">
  <div id="mermaidContainer"></div>
</div> -->

<pre class="mermaid">{{ diagram }}</pre>